var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0C35.7025 0 46 10.2975 46 23C46 35.7025 35.7025 46 23 46C10.2975 46 0 35.7025 0 23C0 10.2975 10.2975 0 23 0Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5871 32.002L14.5727 25.8926H20.9965L15.8035 22.1102L17.7891 16.0008L12.5871 19.7742L7.38516 16.0008L9.37969 22.1102L4.17773 25.8926H10.6016L12.5871 32.002Z",
    fill: "#FFDA44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2672 10.3768L25.7488 12.2455L23.5027 11.374L24.8055 13.3955L23.2871 15.2732L25.6141 14.6533L26.9258 16.6748L27.0516 14.267L29.3875 13.6471L27.1324 12.7846L27.2672 10.3768Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2859 15.8572L31.0047 18.1572L29.0371 19.5498L31.4449 19.5857L32.1547 21.8857L32.9363 19.6037L35.3441 19.6307L33.4125 18.1932L34.1852 15.9111L32.2176 17.3037L30.2859 15.8572Z",
    fill: "#FFDA44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3566 29.1178L33.2965 26.9525L35.0215 25.2725L32.6406 25.6139L31.5805 23.4576L31.1672 25.8295L28.7773 26.1709L30.9156 27.2939L30.5023 29.6748L32.2273 27.9947L34.3566 29.1178Z",
    fill: "#FFDA44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3297 35.6768L27.15 33.2779L29.3871 32.3705L27.0422 31.7955L26.8715 29.3877L25.6047 31.4361L23.2598 30.8611L24.8141 32.7029L23.5383 34.7424L25.7754 33.835L27.3297 35.6768Z",
    fill: "#FFDA44"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCh);
export default __webpack_public_path__ + "static/media/ch.98cc7bdb893a186944c4036c0db0a190.svg";
export { ForwardRef as ReactComponent };